import {
  Box,
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
  LinearProgress,
  Stack,
  Typography,
  useTheme
} from '@mui/material';

import { appFormUtil } from 'modules/common';
import { FileUploadField } from 'modules/components/layer00';

import * as ds from './dataService';
import React, { ReactNode } from 'react';



export type StyledFileUploadFieldProps<T extends object> = {
  form: appFormUtil.InferReturn<T>;
  formFieldPropertyName: keyof appFormUtil.InferReturn<T>['formState'];
  formLabel?: string;
  required?: boolean;
  validationErrorMessage?: string;
  children?: ReactNode | ReactNode[];
};

export const FC = <T extends object,>(props: StyledFileUploadFieldProps<T>) => {
  const [
    fnQuery,
    queryTuple
  ] = ds.useQuery();

  const theme = useTheme();



  return (
    <FormControl
      fullWidth
      required={props.required}
      error={props.validationErrorMessage && props.validationErrorMessage?.length > 1 ? true : false}
    >
      <FormLabel
        sx={{
          marginBottom: '.75rem'
        }}
      >
        <Typography
          variant='formLabel'
        >
          {props.formLabel}
        </Typography>
      </FormLabel>

      <FileUploadField.FC
        allowDrop={true}
        onUploadedFile={async (apiFileId) => {
          props.form.dispatch(
            {
              type: 'UPDATE',
              payload: {
                property: props.formFieldPropertyName,
                value: apiFileId as T[keyof T]
              }
            }
          );

          fnQuery(apiFileId);
        }}
      >
        {(handleClick, isLoading) => (
          (isLoading || queryTuple.loading)
            ? (
              <LinearProgress
                variant='indeterminate'
              />
            )
            : (
              (queryTuple.data.fileName)
                ? (
                  <Box
                    display='flex'
                    padding='1rem'
                    flexDirection='row'
                    borderRadius='1.5rem'
                    columnGap='1rem'
                    bgcolor={theme.palette.secondary.main}
                    justifyContent='space-between'
                    onClick={() => handleClick()}
                  >

                    {/* THIS IS WHERE MODIFY WHAT SHOWS AFTER THE FILE IS UPLOADED */}
                    <Stack
                      direction='column'
                      rowGap='.5rem'
                    >
                      <Box>
                        <Typography
                          variant='bodyBold'
                        >
                          {queryTuple.data.fileName}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography>
                          Size: {queryTuple.data.sizeBytes}
                        </Typography>
                        <IconButton
                          sx={{
                            cursor: 'pointer'
                          }}
                        />
                      </Box>
                    </Stack>
                  </Box>
                )
                : (
                  <Box
                    display='flex'
                    padding='1rem'
                    onClick={() => handleClick()}
                    flexDirection='row'
                    justifyContent='center'
                    alignItems='center'
                    height='3rem'
                    sx={{
                      background: theme.palette.secondary.main,
                      borderRadius: '1.5rem',
                      border: `1px dashed ${theme.palette.primary.main}`
                    }}
                  >
                    {props.children}
                  </Box>
                )))}
      </FileUploadField.FC>
      {
        props.validationErrorMessage && props.validationErrorMessage.length > 1
          ? (
            <FormHelperText variant='standard'>
              {props.validationErrorMessage}
            </FormHelperText>
          )
          : (<></>)
      }
    </FormControl>
  );
};
